module.exports = __webpack_public_path__ + "static/media/videogame.36b49b6e.svg";